// @ts-nocheck
import { PureComponent, Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import { isBrowser, isTablet } from 'react-device-detect'
import { colors, sizes } from '@lmc/common/constants'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'
import Form from '../..'
import Field from '../../../fields'
import { AvatarUpload, ErrorBox, ProfilePicture } from '../../../generic'
import TeamMemberEditFormPersonal from './TeamMemberEditFormPersonal'
import TeamMemberEditFormPermissions from './TeamMemberEditFormPermissions'
import TeamMemberEditFormSectionHeader from './TeamMemberEditFormSectionHeader'
import TeamMemberEditFormRolesPermissionsV2 from './TeamMemberEditFormRolesPermissionsV2'
import { getNominative } from '../../../../common/utils'
import { Button, Arrow, Heading } from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'
import { history } from '../../../../store'
import { Modal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import { handleErrorResponse } from 'utils/error'
import { FormFieldLayout } from '../../../generic'
import { postJSON } from 'common/services/api'
import { UserRole, CommonErrors } from '@lmc/ts-common'
import { getSSOManageAccountLink } from 'utils/sso'
import DeactivatingTeamMemberModal from 'screens/Rostering/ChangeManagement/DeactivatingTeamMemberModal'
import DeletingTeamMemberModal from 'screens/Rostering/ChangeManagement/DeletingTeamMemberModal'
import InsufficientSafeguardingOfficers from './InsufficientSafeguardingOfficers'
import { QueryClient } from 'react-query'
import {
  CARE_MANAGEMENT_LABEL,
  getRoleFieldsProps,
  getPermissionBooleanByTemplate
} from './utils'

/* import { Tooltip } from 'antd'
 */

// Enable when CS will provide article

export class TeamMemberEditForm extends PureComponent {
  state = {
    deleteDialogOpen: false,
    deletePrivacyOfficerDialogOpen: false,
    updatePrivacyOfficerDialogOpen: false,
    updatePrivacyOfficerDialogErrorMessage: undefined,
    imageUploadOpen: false,
    resetPasswordLoading: false,
    insufficientSafeguardingOfficersModalOpen: false,
    deactivatingTeamMemberModalOpen: false,
    deletingTeamMemberModalOpen: false,
    gpConnectEnabled: false
  }

  formRef = null

  setFormRef = (node) => (this.formRef = node)

  handleCancel = () => {
    const { fields, remove } = this.props
    const { id } = fields
    remove({
      onConfirm: () => history.push(`/organisation/team/${id}/profile`)
    })
  }

  handleComplete = (carer) => {
    const { loadLists, showToast } = this.props
    showToast({ title: 'Updated a Team Member' })
    loadLists(['carers', 'logs'])
    this.props.queryClient.invalidateQueries(['carers'])
    this.props.queryClient.invalidateQueries(['incident-list'])
    history.push(`/organisation/team/${carer.id}/profile`)
  }

  handleDelete = async () => {
    const {
      deleteSelf,
      fields,
      showToast,
      hasRota,
      flagsRosteringChangeManagementEnabled
    } = this.props
    const { deletingTeamMemberModalOpen, deleteDialogOpen } = this.state

    if (hasRota && flagsRosteringChangeManagementEnabled) {
      if (!deletingTeamMemberModalOpen) {
        this.setState({ deletingTeamMemberModalOpen: true })
        return
      }
    } else if (!deleteDialogOpen) {
      this.setState({ deleteDialogOpen: true })
      return
    }

    const res = await deleteSelf({
      id: fields.id,
      onComplete: () => {
        showToast({ type: 'info', title: 'Deleted a Team Member' })
      }
    })
    if (res.status === 200) {
      history.push(`/organisation/team`)
      return
    }
    this.setState({ deletePrivacyOfficerDialogOpen: true })

    if (hasRota && flagsRosteringChangeManagementEnabled) {
      this.setState({ deletingTeamMemberModalOpen: false })
    } else {
      this.setState({ deleteDialogOpen: false })
    }
  }

  handleImageSave = (file, imageUri) => {
    this.props.addFormFile({ key: 'picture', file, uri: imageUri })
  }

  handleSubmit = () => {
    const {
      fields,
      updateItem,
      hasRota,
      flagsRosteringChangeManagementEnabled,
      availablePermissionsTemplates,
      rolesAndPermissionsEnabled,
      initial,
      addForm
    } = this.props
    const { deactivatingTeamMemberModalOpen } = this.state

    if (
      hasRota &&
      flagsRosteringChangeManagementEnabled &&
      !fields.active &&
      !deactivatingTeamMemberModalOpen
    ) {
      this.setState({ deactivatingTeamMemberModalOpen: true })
      return
    }

    updateItem({
      url: `list/carers/${fields.id}`,
      onComplete: this.handleComplete,
      onError: (e) => {
        if (this.formRef) {
          this.formRef?.scrollIntoView({ behavior: 'smooth' })
        }

        if (e?.code === CommonErrors.Codes.insufficientSafeguardingOfficers) {
          this.setState({
            insufficientSafeguardingOfficersModalOpen: true
          })
          return
        }

        const privacyOfficerError = handleErrorResponse(e)

        const isPrivacyOfficerError =
          privacyOfficerError &&
          privacyOfficerError?.startsWith('This user is a Privacy Officer in')

        if (isPrivacyOfficerError) {
          this.setState({ updatePrivacyOfficerDialogOpen: true })
          this.setState({
            updatePrivacyOfficerDialogErrorMessage: privacyOfficerError
          })
        }
      }
    })

    if (hasRota && flagsRosteringChangeManagementEnabled && !fields.active) {
      this.setState({ deactivatingTeamMemberModalOpen: false })
    }
  }

  clearPassword = () =>
    this.props.clearFormFields(['password', 'password_confirm'])

  clearPin = () => this.props.clearFormFields(['pin', 'pin_confirm'])

  renderPinField = () => {
    const { fields, initial, role } = this.props
    if (role !== 'carehome-admin') return null
    return (
      <div style={styles.formField}>
        {initial.hasPin ? (
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              buttonText="Change PIN"
              formId={FORM_ID}
              keys={['pin', 'pin_confirm']}
              label="PIN"
              onCancel={this.clearPassword}
              placeholders={['New PIN', 'Confirm PIN']}
              type="changePassword"
              validationTypes="pin"
              values={fields}
              data-testid={
                this.props.testId ? `${this.props.testId}-pin-field` : undefined
              }
            />
          </Suspense>
        ) : (
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={FORM_ID}
              inputType="password"
              keys={['pin', 'pin_confirm']}
              label="PIN"
              placeholders={['New PIN', 'Confirm PIN']}
              type="multiText"
              validationTypes="pin"
              values={fields}
              data-testid={
                this.props.testId ? `${this.props.testId}-pin-field` : undefined
              }
            />
          </Suspense>
        )}
      </div>
    )
  }

  renderSummaryField = (fields) => (
    <div style={styles.summaryText}>
      <label htmlFor="form-summary" style={styles.summaryLabel}>
        Notes
      </label>
      <textarea
        value={fields?.summary || ''}
        style={styles.summary}
        id="form-summary"
        className="FormInput"
        data-testid={
          this.props.testId ? `${this.props.testId}-notes-field` : undefined
        }
        onChange={(e) =>
          this.props.setFormField({
            key: 'summary',
            value: e.target.value
          })
        }
      />
    </div>
  )

  renderSSOResetPassword = () => {
    const { fields, user, showToast } = this.props

    const isCurrentUser = user?.id === fields.id

    const sendResetSSOPassword = () => {
      this.setState({ resetPasswordLoading: true })

      postJSON({
        url: `auth/reset-password/${fields.email}`,
        responseType: 'text'
      })
        .then(() => {
          this.setState({ resetPasswordLoading: false })
          showToast({
            title: 'Reset password email sent. '
          })
        })
        .catch(() => {
          this.setState({ resetPasswordLoading: false })
          showToast({
            title: 'Something went wrong.',
            type: 'error'
          })
        })
    }

    const getResetPasswordField = () => {
      if (isCurrentUser) {
        return (
          <StyledResetHeadingWrapper>
            <a
              href={getSSOManageAccountLink()}
              rel="noreferrer"
              target="_blank"
            >
              <StyledResetHeading level={5}>
                Manage login details for this profile
              </StyledResetHeading>
            </a>
            {/* <Tooltip title="" placement="right" >
              <div>
                <Icon
                  customIcon={IconType.GPQuestionIcon}
                  style={{
                    marginTop: 4,
                    marginLeft: 5,
                  }}
                />
              </div>
            </Tooltip> */}
          </StyledResetHeadingWrapper>
        )
      }

      return (
        <Button
          onClick={sendResetSSOPassword}
          isLoading={this.state.resetPasswordLoading}
          disabled={this.state.resetPasswordLoading}
        >
          Send password reset Email
          <Arrow direction="right" size={16} />
        </Button>
      )
    }

    return (
      <FormFieldLayout label="Password" required style={{ marginBottom: 20 }}>
        {getResetPasswordField()}
      </FormFieldLayout>
    )
  }

  renderMainContent = () => {
    const {
      errors,
      features,
      fields,
      role,
      preferredPeopleNominative,
      initial,
      homes,
      gpConnectEnabled,
      cernerEnabled,
      availablePermissionsTemplates
    } = this.props

    const blockNameChange = fields.homes && fields.homes.length > 1

    const isCarerRole = initial.role === UserRole.carer

    const homesWithHomeGroup = homes?.filter((home) => !!home?.homeGroup)

    const hasMoreHomes = !!homesWithHomeGroup?.length

    const { ROLE_NOTE, ROLE_OPTIONS, isGroupUser } = getRoleFieldsProps(
      initial,
      role,
      preferredPeopleNominative
    )

    return (
      <div>
        <div className="lmc-card" style={styles.primaryInfoContainer}>
          <div style={styles.fieldsContainer}>
            <div style={styles.requiredText}>
              Required fields are marked with{' '}
              <span style={styles.asterisk}>*</span>
            </div>
            <ErrorBox errors={errors} style={{ marginBottom: 10 }} />
            <div style={styles.formField}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  formId={FORM_ID}
                  keys={['name.first', 'name.last']}
                  label="Name"
                  note={blockNameChange && BLOCK_NAME_CHANGE_NOTE}
                  placeholders={['First name', 'Last name']}
                  required
                  type="multiText"
                  disabled={blockNameChange}
                  values={fields}
                  data-testid={
                    this.props.testId
                      ? `${this.props.testId}-name-field`
                      : undefined
                  }
                />
              </Suspense>
            </div>
            <div style={styles.formField}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  className="email-field"
                  formId={FORM_ID}
                  inputType="email"
                  keys="email"
                  label="Email"
                  required
                  type="text"
                  validationTypes="email"
                  values={fields}
                  data-testid={
                    this.props.testId
                      ? `${this.props.testId}-email-field`
                      : undefined
                  }
                />
              </Suspense>
            </div>
            {!isCarerRole && this.renderSSOResetPassword()}
            {this.renderPinField()}
            {!this.props.rolesAndPermissionsEnabled && (
              <div style={styles.formField}>
                <Suspense fallback={<div>Loading...</div>}>
                  <Field
                    className="role-field"
                    formId={FORM_ID}
                    keys="role"
                    label="Role"
                    options={ROLE_OPTIONS}
                    note={ROLE_NOTE}
                    required
                    type="radios"
                    values={fields}
                    data-testid={
                      this.props.testId
                        ? `${this.props.testId}-role-field`
                        : undefined
                    }
                  />
                </Suspense>
              </div>
            )}
            <div style={styles.formField}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  className="role-field"
                  formId={FORM_ID}
                  keys="active"
                  label="Status"
                  options={STATUS_OPTIONS}
                  note={STATUS_NOTE}
                  required
                  type="radios"
                  values={fields}
                  data-testid={
                    this.props.testId
                      ? `${this.props.testId}-status-field`
                      : undefined
                  }
                />
              </Suspense>
            </div>
            {this.props.groupAccessManagementEnabled &&
              !isGroupUser &&
              hasMoreHomes && (
                <div style={styles.formField}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Field
                      className="role-field"
                      formId={FORM_ID}
                      keys="homes"
                      label="Sites"
                      options={homesWithHomeGroup?.map((home) => ({
                        value: home.id,
                        label: home.name
                      }))}
                      required
                      type="checkbox"
                      values={fields}
                      data-testid={
                        this.props.testId
                          ? `${this.props.testId}-sites-field`
                          : undefined
                      }
                    />
                  </Suspense>
                </div>
              )}
            {this.props.teamMemberEnabled && this.renderSummaryField(fields)}
          </div>
        </div>
        {!this.props.rolesAndPermissionsEnabled && (
          <div
            className="lmc-card"
            style={{
              ...styles.sectionContainer,
              marginTop: '-40px'
            }}
          >
            <TeamMemberEditFormSectionHeader
              antdIcon="KeyOutlined"
              iconBackground={colors.darkblue}
              sectionTitle="Permissions"
            />
            <TeamMemberEditFormPermissions
              features={features}
              fields={fields}
              formId={FORM_ID}
              preferredPeopleNominative={preferredPeopleNominative}
              style={styles.fieldsContainer}
              gpConnectEnabled={
                gpConnectEnabled && role === UserRole.careHomeAdmin
              }
            />
          </div>
        )}
        {this.props.rolesAndPermissionsEnabled && (
          <div
            className="lmc-card"
            style={{
              ...styles.sectionContainer,
              marginTop: '-40px'
            }}
          >
            <TeamMemberEditFormSectionHeader
              antdIcon="KeyOutlined"
              iconBackground={colors.darkblue}
              sectionTitle="Roles and Permissions"
            />
            <TeamMemberEditFormRolesPermissionsV2
              features={features}
              fields={fields}
              formId={FORM_ID}
              preferredPeopleNominative={preferredPeopleNominative}
              style={styles.fieldsContainer}
              gpConnectEnabled={
                gpConnectEnabled && role === UserRole.careHomeAdmin
              }
              cernerEnabled={cernerEnabled}
              initial={initial}
              testId={
                this.props.testId
                  ? `${this.props.testId}-roles-permissions`
                  : undefined
              }
              role={role}
              availablePermissionsTemplates={availablePermissionsTemplates}
              setFormField={this.props.setFormField}
            />
          </div>
        )}
        <div
          className="lmc-card"
          style={{
            ...styles.sectionContainer,
            marginTop: 32
          }}
        >
          <TeamMemberEditFormSectionHeader
            icon="profile"
            iconBackground={colors.purple}
            sectionTitle="Personal details"
          />
          <TeamMemberEditFormPersonal
            fields={fields}
            formId={FORM_ID}
            style={styles.fieldsContainer}
            teamMemberEnabled={this.props.teamMemberEnabled}
            testId={
              this.props.testId
                ? `${this.props.testId}-personal-details`
                : undefined
            }
          />
        </div>
      </div>
    )
  }

  renderFooter = (isSubmitting) => (
    <div
      className="lmc-fixed-footer"
      style={{
        ...styles.footer
      }}
    >
      <Button
        id="carer-delete"
        onClick={this.handleDelete}
        style={styles.deleteButton}
        variant="danger"
        icon={<Glyph name="trashcan" />}
      >
        Delete
      </Button>
      <div style={styles.buttonsRow}>
        <Button
          className="carer-edit-cancel"
          onClick={this.handleCancel}
          style={styles.cancelButton}
          variant="default"
          icon={<Glyph name="x" />}
        >
          Cancel
        </Button>
        <Button
          className="carer-edit-save"
          loading={isSubmitting}
          onClick={this.handleSubmit}
          variant="primary"
          icon={<Glyph name="check" />}
          style={styles.saveButton}
        >
          Save
        </Button>
      </div>
    </div>
  )

  render() {
    const { fields, files, initial, isSubmitting, role } = this.props
    const {
      deleteDialogOpen,
      imageUploadOpen,
      deletePrivacyOfficerDialogOpen,
      updatePrivacyOfficerDialogOpen,
      insufficientSafeguardingOfficersModalOpen,
      deactivatingTeamMemberModalOpen,
      deletingTeamMemberModalOpen
    } = this.state

    if (!fields || !files || !initial) return null
    const picture = files && files.picture ? files.picture.uri : fields.picture

    const firstName = fields.name?.first?.trim()
    const lastName = fields.name?.last?.trim()

    const handleInsufficientSafeguardingOfficersModalClose = () => {
      this.props.addForm({ initial, formId: FORM_ID })
      this.setState({ insufficientSafeguardingOfficersModalOpen: false })
    }

    return (
      <div
        ref={this.setFormRef}
        style={styles.wrapper}
        data-testid={this.props.testId}
      >
        <div
          style={styles.mainContainer}
          data-testid={
            this.props.testId
              ? `${this.props.testId}-main-container`
              : undefined
          }
        >
          <ProfilePicture
            edit
            onClick={() => this.setState({ imageUploadOpen: true })}
            type="large"
            style={styles.image}
            url={picture}
            data-testid={
              this.props.testId
                ? `${this.props.testId}-profile-picture`
                : undefined
            }
          />
          {this.renderMainContent()}
        </div>
        {this.renderFooter(isSubmitting, role)}
        {deleteDialogOpen && (
          <ConfirmationDialog
            isOpen={deleteDialogOpen}
            onCancel={() => this.setState({ deleteDialogOpen: false })}
            onConfirmation={this.handleDelete}
            confirmationType="danger"
            verificationText={`${firstName} ${lastName}`}
            finalConfirmationText={`Are you sure you want to permanently delete <strong>${firstName} ${lastName}</strong>?`}
            showFinalConfirmationStep={!deletePrivacyOfficerDialogOpen}
          >
            {ConfirmationBody(fields.name)}
          </ConfirmationDialog>
        )}
        <AvatarUpload
          customButton
          isModalOpen={imageUploadOpen}
          onSave={this.handleImageSave}
          onClose={() => this.setState({ imageUploadOpen: false })}
          data-testid={
            this.props.testId ? `${this.props.testId}-avatar-upload` : undefined
          }
        />

        <Modal
          localisation={{
            title: 'This user is a Privacy Officer',
            confirmText: 'Close'
          }}
          onConfirm={() =>
            this.setState({
              deletePrivacyOfficerDialogOpen: false,
              updatePrivacyOfficerDialogOpen: false,
              deleteDialogOpen: false,
              updatePrivacyOfficerDialogErrorMessage: undefined
            })
          }
          onCancel={() =>
            this.setState({
              deletePrivacyOfficerDialogOpen: false,
              updatePrivacyOfficerDialogOpen: false,
              deleteDialogOpen: false,
              updatePrivacyOfficerDialogErrorMessage: undefined
            })
          }
          isModalVisible={
            deletePrivacyOfficerDialogOpen || updatePrivacyOfficerDialogOpen
          }
          closeButton
          closeOnConfirm={false}
          noPadding
          confirmButtonProps={{ type: 'primary' }}
          testId={
            this.props.testId
              ? `${this.props.testId}-privacy-officer-modal`
              : undefined
          }
        >
          <ModalContentWrapper>
            <div>
              <StyledText weight="normal">
                {deletePrivacyOfficerDialogOpen &&
                  `Users who are set as a Home’s Privacy Officer cannot be
                         deleted, set to inactive or have their role changed.`}
                {updatePrivacyOfficerDialogOpen &&
                  this.state.updatePrivacyOfficerDialogErrorMessage}
              </StyledText>
            </div>
            <div style={{ marginTop: 20 }}>
              <StyledText weight="normal">
                {deletePrivacyOfficerDialogOpen &&
                  `To make these changes first remove this user from Privacy
                  Officer list under the Settings `}
                {updatePrivacyOfficerDialogOpen &&
                  `To make these changes first remove this user from Privacy
                  Officer list under other homes`}
                {deletePrivacyOfficerDialogOpen && (
                  <StyledSpan
                    onClick={() => history.push(`/settings/privacy-officers`)}
                  >
                    here
                  </StyledSpan>
                )}
                .
              </StyledText>
            </div>
          </ModalContentWrapper>
        </Modal>

        {deactivatingTeamMemberModalOpen && (
          <DeactivatingTeamMemberModal
            showModal={deactivatingTeamMemberModalOpen}
            onCancel={() =>
              this.setState({ deactivatingTeamMemberModalOpen: false })
            }
            onConfirm={this.handleSubmit}
            name={`${fields.name?.first} ${fields.name?.last}`}
            carerId={fields.id}
          />
        )}

        {deletingTeamMemberModalOpen && (
          <DeletingTeamMemberModal
            showModal={deletingTeamMemberModalOpen}
            onCancel={() =>
              this.setState({ deletingTeamMemberModalOpen: false })
            }
            onConfirm={this.handleDelete}
            name={`${fields.name?.first} ${fields.name?.last}`}
            carerId={fields.id}
          />
        )}

        <InsufficientSafeguardingOfficers
          showModal={insufficientSafeguardingOfficersModalOpen}
          handleModalClose={handleInsufficientSafeguardingOfficersModalClose}
        />
      </div>
    )
  }
}
const STATUS_NOTE = 'Only active team members can access Log my Care'
const BLOCK_NAME_CHANGE_NOTE =
  "Changes to this team member's name has been disabled because they have access to multiple sites. Please contact support if you'd like to change their name."

const STATUS_OPTIONS = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false }
]
const ConfirmationBody = (name) => (
  <div>
    Are you sure you want to delete{' '}
    <strong>
      {name.first} {name.last}
    </strong>
    ? If you go ahead, it can't be undone.
    <br />
    <br />
    This team member will no longer be able to log in to the Carer App or the
    Care Office. Their log history will still be visible.
  </div>
)

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

const ModalContentWrapper = styled.div`
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.color.neutral.color8};
  padding-top: 24px;
  padding-bottom: 24px;
`

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.color.status.primary};
  text-decoration: underline;
  cursor: pointer;
`

const StyledResetHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.primary};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
`

const StyledResetHeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const isDesktop = isBrowser || isTablet
export const FORM_ID = 'editTeamMember'

const styles = {
  asterisk: {
    color: colors.red,
    fontWeight: 600
  },
  cancelButton: {
    marginRight: 10
  },
  deleteButton: {
    color: 'white'
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    minWidth: '60%',
    width: isDesktop ? '60%' : '100%'
  },
  footer: {
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'
  },
  formField: {
    paddingBottom: 20
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40
  },
  image: {
    position: 'relative',
    zIndex: 1
  },
  mainContainer: {
    margin: '0 auto',
    paddingBottom: 90,
    maxWidth: sizes.childScreen
  },
  primaryInfoContainer: {
    marginTop: 0,
    paddingTop: 70,
    position: 'relative',
    bottom: 70
  },
  requiredText: {
    margin: '20px 0px'
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20
  },
  sectionContainer: {
    marginTop: 60,
    paddingBottom: 25
  },
  wrapper: {
    padding: '0px 20px',
    paddingTop: 24
  },
  buttonsRow: {
    display: 'flex'
  },
  saveButton: {
    marginLeft: 4
  },
  summary: {
    minHeight: 130,
    height: '100%',
    minWidth: '100%',
    maxWidth: '100%'
  },
  summaryContainer: {
    flex: 1
  },
  summaryLabel: {
    fontWeight: 'bold'
  },
  summaryText: {
    minHeight: 150,
    margin: 'auto',
    width: '100%'
  }
}

TeamMemberEditForm.propTypes = {
  clearFormFields: PropTypes.func.isRequired,
  deleteSelf: PropTypes.func.isRequired,
  features: PropTypes.object.isRequired,
  hasRota: PropTypes.bool,
  flagsRosteringChangeManagementEnabled: PropTypes.bool
}

const mapDispatchToProps = (dispatch) => ({
  addForm: ({ initial, formId }) =>
    dispatch(
      Actions.addForm({
        initial,
        formId
      })
    ),
  clearFormFields: (fields) =>
    dispatch(
      Actions.clearFormFields({
        fields,
        formId: FORM_ID
      })
    ),
  deleteSelf: ({ id, onComplete }) =>
    dispatch(
      Operations.deleteFormItem({
        id,
        list: 'carers',
        onComplete
      })
    ),
  loadLists: (lists) => dispatch(Operations.loadLists(lists))
})

const mapStateToProps = (state) => ({
  features: state.global.home,
  role: state.global.user && state.global.user.role,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  user: state.global.user,
  homes: state.data.homes,
  gpConnectEnabled: !!state.global.home.odsCode && !!state.global.home.asidCode,
  cernerEnabled: state.global.home.features?.cerner?.enabled,
  availablePermissionsTemplates: state.global?.permissionTemplates || []
})

const wrappedForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberEditForm)

export default Form(wrappedForm, FORM_ID)
